import styled from '@emotion/styled';
import Image from 'next/image';
import BlogContentCardText from '../BlogContentCardText';
import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import { gray } from '@styles/Colors';
import { useRouter } from 'next/router';
import { PostsResponse } from 'models/swagger-spring/data-contracts';
import { useGetCachePostsCategoryById } from '@hooks/fetch/spring/posts-category/useGetPostsCategory';

const BlogReadGoodContentCardContainer = styled.div`
  display: flex;
  align-items: flex-start;
  align-content: flex-start;
  gap: 24px;
  flex-wrap: wrap;
`;

const BlogReadGoodContentCardWrapper = styled.div`
  display: flex;
  width: 344px;
  height: 404px;
  flex-direction: column;P
  align-items: flex-start;
  gap: 16px;
  cursor: pointer;
`;

const BlogImageWrapper = styled.div`
  min-width: 344px;
  min-height: 280px;
`;

type Props = {
  data: PostsResponse;
};

const postsType = 'BLOG';

export default function BlogReadGoodContentCard({ data }: Props) {
  const router = useRouter();
  const category = useGetCachePostsCategoryById(postsType, data.postsCategoryId);

  return (
    <>
      <BlogReadGoodContentCardContainer onClick={() => router.push(`/blog/${data.id}`)}>
        <BlogReadGoodContentCardWrapper>
          <BlogImageWrapper>
            <Image
              src={`${process.env.NEXT_PUBLIC_CDN_URL}${data.thumbnailImageUrl}`}
              alt="good-now-content-image"
              width={344}
              height={280}
              objectFit="contain"
            />
          </BlogImageWrapper>
          <BlogContentCardText title={data.title} category={category}>
            <Typography variant={TypoVariant.B4} color={gray.gray7}>
              {data.createdAt}
            </Typography>
          </BlogContentCardText>
        </BlogReadGoodContentCardWrapper>
      </BlogReadGoodContentCardContainer>
    </>
  );
}
